module.exports = __webpack_public_path__ + "a43ae9218c5c5127fcaf9a3ad3faf102.png";